<template>
  <div>
    <v-dialog v-model="bShowConvertir" persistent max-width="655px">
      <v-card class="pa-0">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer></v-spacer>
          <span class="mdlHeadForms">{{ sTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn  color="btncolor-dark" @click="CloseDialog()" icon small dark outlined>
            <v-icon size="15px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-container fluid>
            <v-row class="no-gutters">
              <v-col cols="12" class="text-center">
              <v-list dense>
              <v-list-item @click="convertirAction('Vulnerabilidad')">
                <v-list-item-content>
                  <v-list-item-title> <v-icon left>mdi-car-brake-alert</v-icon>Vulnerabilidad</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="convertirAction('Amenaza')">
                <v-list-item-content>
                  <v-list-item-title> <v-icon left>mdi-fire-alert</v-icon>Amenaza</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              </v-list>
              </v-col>
            </v-row>
            <!-- <v-row class="no-gutters mt-2">
              <v-col cols="12" class="text-center">
                <v-btn color="btncolor" dark class="mx-1" @click="CloseDialog()" >Guardar</v-btn>
                <v-btn color="btncolor" dark class="mx-1" @click="CloseDialog()"  >Cancelar</v-btn>
              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ModalMensajeGeneral v-model="oModalMensaje.bModalVisible" :sMensaje="oModalMensaje.sMensaje" :nTipo="oModalMensaje.nTipo" @respuesta="ProcesarConvertir"/>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'

export default {
  name:'BtnConvertir',
  props:{
    bShowConvertir:{
      type: Boolean,
      default: false
    },
    oDataParent: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      sTitle: 'Clasificar',
      esAmenaza: false,                        // Indica si se convierte a amenaza o a vulnerabilidad 
      oModalMensaje: {
        bModalVisible: false,
        sMensaje: '',
        nTipo: 1
      },
    }
  },
  methods: {
    convertirAction(val){
      if(val == 'Vulnerabilidad'){
        this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
        this.oModalMensaje.sMensaje = 'Estas seguro de convertir en Vulnerabilidad'
        this.esAmenaza = false
      }else{
        this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
        this.oModalMensaje.sMensaje = 'Estas seguro de convertir en Amenaza'
        this.esAmenaza = true
      }
    },
    CloseDialog(){
     this.$emit('input', false)
    },
    async ProcesarConvertir(bRespuesta){
      if(bRespuesta){
        const oBody = {
          aElementos :[parseInt(this.oDataParent.ID_RiesgoNovedad)],
          convertirA : this.esAmenaza ? 2 : 1     // Se pasa el id de la clasificacion segun tabla RiesgoClasificaciones
        }
        const axiosConvertir = await axiosServices.postConfiguration('/riesgos/convertir', oBody, true)
        if(axiosConvertir.sStatus == 'success') {         
          this.aElementosSelect = []  
          this.$emit('refrescar')
          this.CloseDialog()
        }
      } 
    }  
  },
  watch:{

  }

}
</script>
<style lang="scss" scoped>
</style>